export default "__VITE_ASSET__Bfscbuoo__"